import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';

export const AnnuitySurvivorBenefit = () => {
  const { control } = useFormContext<FormFields>();

  return (
    <Controller
      control={control}
      name="bankAccount.AnnuitySurvivorBenefit"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label="Survivor Benefit"
        />
      )}
    />
  );
};
